

export type MomentDateType = moment.Moment & {
    _dateOnly   : boolean
}

export function momentDate(arg:any):MomentDate {
    return createMomentDate(arg) as MomentDate
}


// IT CREATES A COPY OF THE VALUE !!!!
export function createMomentDate(value:any):MomentDateType {

    let result = moment(value).startOf('day')

    // @ts-ignore
    result._dateOnly = true

    // result.toJSON = toJSON
    result.toJSON = ()=>{
        return result.format("YYYY-MM-DD")
    }

    return result as MomentDateType
}